import { Component } from 'react';
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';
import FadeIn from './FadeIn';

let id = 0;

class Portfolio extends Component {
  render() {
    if (!this.props.data) return null;

    const projects = this.props.data.projects.map(function (projects) {
      let projectImage = 'images/portfolio/' + projects.image;

      return (
        <div key={id++} className="columns facility-item">
          <div className="item-wrap">
            <Zoom>
              <img
                alt={projects.title}
                src={projectImage}
                style={{
                  width: '100%',
                  borderRadius: '8px',
                  cursor: 'zoom-in',
                }}
              />
            </Zoom>
            <div style={{ textAlign: 'center' }}>{projects.title}</div>
          </div>
        </div>
      );
    });

    return (
      <section id="facility">
        <FadeIn>
          <div className="row">
            <div className="twelve columns collapsed">
              <h1>Facility</h1>
              <div id="facility-wrapper" className="bgrid-thirds s-bgrid-thirds cf">
                {projects}
              </div>
            </div>
          </div>
        </FadeIn>
      </section>
    );
  }
}

export default Portfolio;

